import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";

export function useCarrierAccountsForAutomation() {
  const merchantRpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  const carrierAccountsLoad = useLoad(
    async (signal: AbortSignal) => {
      const result = await merchantRpcClient.getCarrierAccounts(null, {
        signal,
      });
      return result.merchantCarrierAccounts;
    },
    [merchantRpcClient],
  );

  const carrierAccounts = carrierAccountsLoad.value ?? [];

  return {
    carrierAccounts,
    carrierAccountsLoading: carrierAccountsLoad.pending,
  };
}
